/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { defineMessages } from 'react-intl';

export const cluTeachingBubbleMessages = defineMessages({
    filterViewTitle: { id: 'clu.cluTeachingBubbleMessages.filterViewTitle', defaultMessage: 'Filter view' },
    selectIntentTitle: { id: 'clu.cluTeachingBubbleMessages.selectIntentTitle', defaultMessage: 'Select intent' },
    newUtteranceTitle: { id: 'clu.cluTeachingBubbleMessages.newUtteranceTitle', defaultMessage: 'Label entities' },
    saveChangesTitle: { id: 'clu.cluTeachingBubbleMessages.saveChangesTitle', defaultMessage: 'Save the changes' },
    editUtteranceTitle: { id: 'clu.cluTeachingBubbleMessages.editUtteranceTitle', defaultMessage: 'Edit utterance' },
    examineModelTitle: { id: 'clu.cluTeachingBubbleMessages.examineModelTitle', defaultMessage: 'Examine your model' },
    moveUtteranceTitle: { id: 'clu.cluTeachingBubbleMessages.moveUtteranceTitle', defaultMessage: 'Move utterance(s)' },
    deleteUtteranceTitle: { id: 'clu.cluTeachingBubbleMessages.deleteUtteranceTitle', defaultMessage: 'Delete utterance(s)' },
    createNewProjectTitle: { id: 'clu.cluTeachingBubbleMessages.createNewProjectTitle', defaultMessage: 'Create new project' },
    modelEvaluationTitle: { id: 'clu.cluTeachingBubbleMessages.modelEvaluationTitle', defaultMessage: 'View model evaluation' },
    addEntityButtonTitle: { id: 'clu.cluTeachingBubbleMessages.addEntityButtonTitle', defaultMessage: 'Add and label entities' },
    editUtteranceBody: { id: 'clu.cluTeachingBubbleMessages.editUtteranceBody', defaultMessage: 'Edit the selected utterance.' },
    overlapButtonTitle: { id: 'clu.cluTeachingBubbleMessages.overlapButtonTitle', defaultMessage: 'Check out the Overlap Method' },
    dataTaggingPaletteTitle: { id: 'clu.cluTeachingBubbleMessages.dataTaggingPaletteTitle', defaultMessage: 'Label your utterances' },
    deleteUtteranceBody: { id: 'clu.cluTeachingBubbleMessages.deleteUtteranceBody', defaultMessage: 'Delete the selected utterance(s).' },
    longestOverlapCardTitle: { id: 'clu.cluTeachingBubbleMessages.longestOverlapCardTitle', defaultMessage: 'Different types of overlap' },
    createNewCLUProjectBody: {
        id: 'clu.cluTeachingBubbleMessages.createNewCLUProjectBody',
        defaultMessage: 'Click create a new project to start a new Conversational Language Understanding project.'
    },
    createNewOrchestrationProjectBody: {
        id: 'clu.cluTeachingBubbleMessages.createNewOrchestrationProjectBody',
        defaultMessage: 'Click create a new project to start a new Orchestration workflow project.'
    },
    filterViewBody: {
        id: 'clu.cluTeachingBubbleMessages.filterViewBody',
        defaultMessage: 'You can see the utterances for any set of intents and entities by selecting them for in the filter pane.'
    },
    addEntityButtonBody: {
        id: 'clu.cluTeachingBubbleMessages.addEntityButtonBody',
        defaultMessage:
            'Select Add entity to begin adding the entities you want to label. You can use the highlighter icon next to the entity to label the text or select the text in the utterance to label.'
    },
    dataTaggingPaletteBody: {
        id: 'clu.cluTeachingBubbleMessages.dataTaggingPaletteBody',
        defaultMessage: 'Use this pane to create entities to label utterances with entities.'
    },
    newUtteranceBody: {
        id: 'clu.cluTeachingBubbleMessages.newUtteranceBody',
        defaultMessage:
            'Highlight the text and select an entity to apply it as a label for Learned entity components. Alternatively use the highlighter on the right pane.'
    },
    examineModelBody: {
        id: 'clu.cluTeachingBubbleMessages.examineModelBody',
        defaultMessage: 'Once your model is trained, you can view details such as performance metrics and information about the test set.'
    },
    modelEvaluationBody: {
        id: 'clu.cluTeachingBubbleMessages.modelEvaluationBody',
        defaultMessage:
            'When you enable evaluation during model training, you’ll be able to click on the model’s name and view its evaluation results.'
    },
    moveUtteranceBody: {
        id: 'clu.cluTeachingBubbleMessages.moveUtteranceBody',
        defaultMessage: 'Move the selected utterance(s) to the chosen intent.'
    },
    saveChangesBody: {
        id: 'clu.cluTeachingBubbleMessages.saveChangesBody',
        defaultMessage: 'After editing the utterance, you should save the changes.'
    },
    selectIntentBody: {
        id: 'clu.cluTeachingBubbleMessages.selectIntentBody',
        defaultMessage: 'You should select an intent first to create an utterance'
    },
    overlapButtonBody: {
        id: 'clu.cluTeachingBubbleMessages.overlapButtonBody',
        defaultMessage:
            'You have just added 2 different components to the {name} entity (Learned and {type}). Check out the Overlap Method for the entity to understand how the components can interact with each other.'
    },
    longestOverlapCardBody: {
        id: 'clu.cluTeachingBubbleMessages.longestOverlapCardBody',
        defaultMessage:
            'Overlap methods are clickable, and you can navigate between them and by selecting one you are choosing to assign it for this entity.'
    }
});
